import { PROYECT, api_get, api_post, api_put } from "services/api";

import {
  startRequest,
  stopRequest,
  setSnackbar
} from "redux/actions/search/searchActions";

import { addLabelArray } from "helpers/addLabelArray";
import { ROUTES_TYPES } from "redux/reducers/buildings/routes/routesTypes";

const {
  SET_ROUTES,
  NEW_ROUTE,
  SET_NEW_ROUTE,
  EDIT_ROUTE,
  SET_EDITED_ROUTE,
  CLEAR_ROUTES,
  HANDLE_ROUTES_BUILDINGS_INPUTS,
} = ROUTES_TYPES;

const urlRoutes = `${process.env.REACT_APP_URL}${PROYECT}/buildings/routes`;
const getUrlEmployees = idStation =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/routes/stations/${idStation}/employees`;

export function newRoute() {
  return {
    type: NEW_ROUTE
  };
}
export function clearRoutes() {
  return {
    type: CLEAR_ROUTES
  };
}

export function editRoute(id) {
  return {
    type: EDIT_ROUTE,
    payload: id
  };
}

export const handleRoutesBuildingsInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_ROUTES_BUILDINGS_INPUTS, payload: { key, value } });
};

export const fetchRoutes = (idStation = null) => async dispatch => {
  dispatch(startRequest());
  const urlEmployees = getUrlEmployees(idStation);
  try {
    const [routes, employees] = await Promise.all([
      api_get(`${urlRoutes}/stations/${idStation}`),
      api_get(urlEmployees)
    ]);

    dispatch({
      type: SET_ROUTES,
      payload: {
        routes,
        employees: addLabelArray(employees, "name")
      }
    });

    dispatch(stopRequest());
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequest());
  }
};

export const fetchNewRoute = body => async dispatch => {
  dispatch(startRequest());
  try {
    const response = await api_post(urlRoutes, body);
    const newRoute = Array.isArray(response) ? response[0] : response;

    dispatch({
      type: SET_NEW_ROUTE,
      payload: newRoute
    });

    dispatch(stopRequest());
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequest());
  }
};

export const fetchEditRoute = (body, id) => async dispatch => {
  dispatch(startRequest());
  try {
    const response = await api_put(`${urlRoutes}/${id}`, body);
    const editedRoute = Array.isArray(response) ? response[0] : response;

    dispatch({
      type: SET_EDITED_ROUTE,
      payload: editedRoute
    });

    dispatch(stopRequest());
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequest());
  }
};
